import { defineComponent as _defineComponent } from 'vue'
import type { ICoursePreview } from "@/types/entities/ICoursePreview";
import { computed } from "vue";
import { useRouter } from "vue-router";
import routesName from "@/utils/constants/routesName";
import useDayjs from "@/composables/useDayjs";
import CourseProgressBar from "@/components/CourseProgressBar.vue";
import languages from "@/utils/constants/languages";
import { CourseStatusEnum } from "@/utils/enum/CourseStatusEnum";
import { useCourse } from "@/composables/useCourse";

interface Props {
  previewData: ICoursePreview;
  courseId: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CourseInfoPanel',
  props: {
    previewData: {},
    courseId: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;
const router = useRouter();
const { formatDate } = useDayjs();
const { sortCredits } = useCourse();

const credits = computed(() => props.previewData.credits);
const courseHasNotStarted = computed<boolean>(
  () => !props.previewData.enrolled_at
);

const getEstimatedTime = (totalMinutes: number): string => {
  if (totalMinutes < 0 || totalMinutes >= 6000) {
    return "0";
  }
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const hoursStr = String(hours).padStart(2, "0");
  const minutesStr = String(minutes).padStart(2, "0");
  return `${hoursStr}:${minutesStr}`;
};

const getPrice = (price: string): string => {
  return Number(price) ? `${price}$` : "Free";
};

const getLanguages = (): string => {
  return props.previewData.languages
    .map((lang) => getLanguageName(lang))
    .join(",");
};
const getLanguageName = (value: string): string => {
  const foundedLang = languages.find((language) => language.value === value);
  return foundedLang ? foundedLang.label : "";
};

const startCourse = (): void => {
  const query: Record<string, string> = {};
  if (props.previewData.status === CourseStatusEnum.inReview) {
    query.inReview = "true";
  }
  if (props.previewData.is_expired) {
    query.isExpired = String(props.previewData.is_expired);
  }
  router.push({
    name: routesName.onboardingStep,
    params: { id: props.courseId, step: "step-1" },
    query,
  });
};

const startFollowUp = (): void => {
  router.push({
    name: routesName.courseFollowUp,
    params: { id: props.courseId },
    query: { inReview: "true" },
  });
};

const startCourseButton = computed<string>(() => {
  return props.previewData.certified_at ? "View Again" : "Continue Learning";
});

const __returned__ = { props, router, formatDate, sortCredits, credits, courseHasNotStarted, getEstimatedTime, getPrice, getLanguages, getLanguageName, startCourse, startFollowUp, startCourseButton, computed, get useRouter() { return useRouter }, get routesName() { return routesName }, get useDayjs() { return useDayjs }, CourseProgressBar, get languages() { return languages }, get CourseStatusEnum() { return CourseStatusEnum }, get useCourse() { return useCourse } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})